<template>
    <div class="centered">
        <b-container class="login">
            <b-form-group class="login">
                <div class="backgroundForm" id="login">
                    <h2 class="font-bold font-login">{{isRegister ? "Sign Up" : "Login"}}</h2>
                    <b-alert variant="danger" v-model="alert"
                             class="mt-3"
                    >{{error}}
                    </b-alert>
                    <div class="form-group">
                        <label for="username" class="block">{{!isRegister ? 'Username or Email' :'Username'}}</label>
                        <input type="text" class="form-control" v-on:keyup="usernameExist" v-model="username"
                               id="username">
                    </div>
                    <div class="form-group" v-bind:hidden="!isRegister">
                        <label for="email" class="block">Email</label>
                        <input type="text" class="form-control" id="email" v-model="email" @keyup="emailExist">
                    </div>
                    <div class="form-group">
                        <label for="password" class="block">Password</label>
                        <input type="password" class="form-control" id="password" v-model="password"
                               @keyup.enter="logIn">
                    </div>
                    <div class="form-group" v-bind:hidden="!isRegister">
                        <label for="confirm_password" class="block">Confirm Password</label>
                        <input type="password" class="form-control" id="confirm_password" v-model="confirmPassword"
                               @keyup.enter="signUp">
                    </div>
                    <div class="form-group">

                        <p class="text-center">{{isRegister ? "Already have an account?":"Don't have account?"}} <a
                                href="#"
                                @click="switchSignUpLogin">
                            {{isRegister ? "Login":"Sign up here"}}</a></p>
                        <p class="text-center" :hidden="isRegister"><a
                                href="#"
                                @click="$router.push({path:'/forgot-pass'})">
                            Forgot Password</a></p>
                    </div>
                    <b-button @click="customButton" class="customBtn"
                              variant="primary">{{ isRegister ? "Sign Up":"Login"}}
                    </b-button>
                </div>
            </b-form-group>

        </b-container>
    </div>
</template>

<script>
    import {userServices} from "@/services"
    import tokenManager from "../services/tokenManager";

    export default {
        name: "Login",
        created() {
            if (!tokenManager.isLogin()) {
                this.$store.dispatch('signOut');
            }
        },
        data() {
            return {
                alert: false,
                error: "",
                isRegister: false,
                username: "",
                password: "",
                email: "",
                confirmPassword: "",
                reg: /^(([^<>()[[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
            }
        },
        methods: {
            customButton() {
                this.isRegister ? this.signUp() : this.logIn();
            },
            switchSignUpLogin() {
                this.isRegister = !this.isRegister;
                this.alert = false;
                this.error = "";
                this.username = "";
                this.password = "";
                this.email = "";
                this.confirmPassword = "";
            },
            onError(e) {
                this.alert = true;
                this.error = e.toString();
            },
            usernameExist() {
                if (!this.isRegister) {
                    return;
                }
                if (this.reg.test(this.username)) {
                    this.alert = true;
                    this.error = "Vui lòng nhập đúng định dạng username";
                    return;
                }
                let data = {
                    username: this.username,
                }
                userServices.usernameExist(data).catch(this.onError).then((response) => {
                    let data = response.data;
                    if (data.code !== 0) {
                        this.onError(data.message);
                        // console.log(data.data.token);
                        // tokenManager.setToken(data.data.token);
                        // this.$router.push({name: "Home"});
                    } else {
                        this.alert = false;
                        this.error = "";
                    }
                });
            },
            emailExist() {
                if (!this.isRegister) {
                    return;
                }
                let data = {
                    email: this.email,
                }
                userServices.emailExist(data).catch(this.onError).then((response) => {
                    console.log(response);
                    let data = response.data;
                    if (data.code !== 0) {
                        this.onError(data.message);
                        // console.log(data.data.token);
                        // tokenManager.setToken(data.data.token);
                        // this.$router.push({name: "Home"});
                    } else {
                        this.alert = false;
                        this.error = "";
                    }
                });
            },
            logIn() {
                let data = {
                    username: this.username,
                    password: this.password
                }
                userServices.login(data).catch(this.onError).then((response) => {
                    let data = response.data;
                    if (data.code === 0) {
                        // console.log(data.data.token);
                        tokenManager.setToken(data.data.token);
                        this.$store.dispatch('loggedIn');
                        this.$router.push({path: "/profile"});
                    } else {
                        // console.log(data.message);
                        this.alert = true;
                        this.error = data.message;
                    }
                });
            },
            signUp() {
                let data = {
                    username: this.username,
                    email: this.email,
                    password: this.password,
                    confirm_password: this.confirmPassword
                }
                userServices.signUp(data).catch(this.onError).then((resp) => {
                    let respData = resp.data;
                    //console.log(respData);
                    if (respData.code === 0) {
                        this.isRegister = false;
                        this.alert = false;
                        this.error = "";
                        this.$toasted.success("Đăng kí tài khoản thành công, kiểm tra email và đăng nhập lại")
                        // this.$router.push({path: "/login"});
                        return;
                    }
                    this.alert = true;
                    this.error = respData.message;
                });
            },
            confirmSignUpSuccessfully() {
                // this.$router.push({path: "/login"})
            }
        }
    }
</script>

<style scoped>
    .login {
        /*background: wheat;*/
    }

    #login {
        padding: 30px;
        text-align: center;
    }

    body {
        background: rgba(0, 0, 0, 0.76);
    }

    .font-login {
        font-family: 'Kaushan Script', serif;
    }

    .centered {
        position: fixed;
        top: 35%;
        left: 50%;
        /* bring your own prefixes */
        transform: translate(-50%, -50%);
    }

    label {
        float: left;
    }

    .backgroundForm {
        background: white;
        /* float: left; */
        text-align: center;
        margin: auto;
        border-radius: 0.9rem;
    }

    .customBtn {
        border-radius: 50px;
        padding: 0.5rem 5rem;
    }

</style>